import store from '../store';
import { apiSlice } from '../apiSlice';

/**
 * Add a notification to the store
 * @param {object} notification - The notification object to add
 */
export const addNotification = (notification) => {
  const orgId = store.getState().auth.organizationId;
  const userId = notification.userId;

  const currentCache = apiSlice.endpoints.fetchNotifications.select({
    orgId,
    urlParams: { showUnreadOnly: 'false', userId }
  })(store.getState());

  const currentNotifications = currentCache?.data?.notifications || [];
  const updatedNotifications = [notification, ...currentNotifications];

  try {
    store.dispatch(apiSlice.util.updateQueryData('fetchNotifications', {
      orgId,
      urlParams: { showUnreadOnly: 'false', userId: userId || '' }
    }, (draft) => {
      draft.notifications = updatedNotifications;
      draft.total = (draft.total || 0) + 1;
    }));
  } catch (error) {
    console.error('Error updating fetchNotifications cache:', error);
  }

  try {
    store.dispatch(apiSlice.util.updateQueryData('fetchUnreadNotificationCount', {
      orgId,
      userId: userId || ''
    }, (draft) => {
      draft.unreadNotificationCount = (draft.unreadNotificationCount || 0) + 1;
    }));
  } catch (error) {
    console.error('Error updating fetchUnreadNotificationCount cache:', error);
  }
};
